import React, { useContext, useEffect } from "react";
import NewContactPageHero from "./NewContactPageHero";
import NewContactForm from "./NewContactForm";
import { AuthContext } from "../../context/AuthContext";

const NewContactPage = () => {
  const dataContext = useContext(AuthContext);

  useEffect(() => {
    // Set Page Title
    document.title = "Contact TechQilla | Digital Marketing & IT Solutions";

    // --- Description ---
    let metaDescription = document.querySelector<HTMLMetaElement>(
      "meta[name='description']",
    );
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Get in touch with TechQilla for digital marketing, web development, SaaS, and IT solutions. Let’s discuss how we can grow your business.",
    );

    // --- Keywords ---
    let metaKeywords = document.querySelector<HTMLMetaElement>(
      "meta[name='keywords']",
    );
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", "Contact Digital Marketing Agency");
    // --- Canonical ---
    let linkTag = document.querySelector<HTMLLinkElement>(
      "link[rel='canonical']",
    );
    if (!linkTag) {
      linkTag = document.createElement("link");
      linkTag.rel = "canonical";
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute("href", "https://www.techqilla.com/contact");
  }, []);

  if (!dataContext) return null;
  const { theme } = dataContext;
  return (
    <div>
      <NewContactPageHero />
      <div
        className={`${
          theme === "dark"
            ? "bg-primary text-white transition-all duration-500"
            : "bg-[#141414] text-white transition-all duration-500"
        } `}
      >
        <div className="flex flex-col mx-auto max-w-screen-2xl items-center justify-center overflow-hidden pt-8 lg:pt-[80px]">
          <NewContactForm />
        </div>
      </div>
    </div>
  );
};

export default NewContactPage;
